import { ofType } from "redux-observable"
import { catchError, EMPTY, mergeMap } from "rxjs"
import EventBus from "../../../common/EventBus"
import { PRODUCT_QOH_ADJUSTMENT_SUCCESSFUL_MESSAGE } from "../../../utils/product/utils"
import { Action } from "../actions/actions"
import { ACTION_TYPES } from "../actions/types"
import { Selector } from "../selectors/selectors"
import { Service } from "../service/service"

export const patchEpic = (action$, $state) => {
    return action$.pipe(
        ofType(ACTION_TYPES.PATCH),
        mergeMap(({ payload }) => {
            const product = Selector.get($state.value)
            return Service.patch(product.id, payload)
                .then(res => {
                    return Action.set(res)
                })
        }),
        catchError(() => EMPTY)
    )
}

export const generateQohAdjustment = (action$) => {
    return action$.pipe(
        ofType(ACTION_TYPES.GENERATE_QUANTITY_ON_HAND_ADJUSTMENT),
        mergeMap(({payload}) => {
            return Service.generateQohAdjustment(payload.inventoryLocationId, payload.itemAdjustment.productId, payload).then(res => {
                if (res && !res.error) {
                    EventBus.dispatch(EventBus.TopicSendSuccessNotification,{
                        message: PRODUCT_QOH_ADJUSTMENT_SUCCESSFUL_MESSAGE
                    })
                    return Action.set(res)
                }
            })
        }),
        catchError(() => EMPTY)
    )
}


// WEBPACK FOOTER //
// ./src/state/product/epics/epics.ts